import SvgIcon from "../shared/components/SvgIcon";

//ARCS
export const SteadyIcon = (props) => (
  <SvgIcon xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 12' fill='none' {...props}>
    <path d='M0 0H2V12H0V0Z' fill={props.fillColor || 'black'} />
    <path d='M3 2H5V12H3V2Z' fill={props.fillColor || 'black'} />
    <path d='M8 0H6V12H8V0Z' fill={props.fillColor || 'black'} />
    <path d='M9 2H11V12H9V2Z' fill={props.fillColor || 'black'} />
    <path d='M14 0H12V12H14V0Z' fill={props.fillColor || 'black'} />
  </SvgIcon>
);

export const AscendingIcon = (props) => (
  <SvgIcon xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 12' fill='none' {...props}>
    <path d='M0 8H2V12H0V8Z' fill={props.fillColor || 'black'} />
    <path d='M3 6H5V12H3V6Z' fill={props.fillColor || 'black'} />
    <path d='M8 4H6V12H8V4Z' fill={props.fillColor || 'black'} />
    <path d='M9 2H11V12H9V2Z' fill={props.fillColor || 'black'} />
    <path d='M14 0H12V12H14V0Z' fill={props.fillColor || 'black'} />
  </SvgIcon>
);

export const DescendingIcon = (props) => (
  <SvgIcon xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 12' fill='none' {...props}>
    <path d='M0 0H2V12H0V0Z' fill={props.fillColor || 'black'} />
    <path d='M3 2H5V12H3V2Z' fill={props.fillColor || 'black'} />
    <path d='M8 4H6V12H8V4Z' fill={props.fillColor || 'black'} />
    <path d='M9 6H11V12H9V6Z' fill={props.fillColor || 'black'} />
    <path d='M14 8H12V12H14V8Z' fill={props.fillColor || 'black'} />
  </SvgIcon>
);

export const MiddleCrescendoIcon = (props) => (
  <SvgIcon xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 12' fill='none' {...props}>
    <path d='M0 8H2V12H0V8Z' fill={props.fillColor || 'black'} />
    <path d='M3 4H5V12H3V4Z' fill={props.fillColor || 'black'} />
    <path d='M8 0H6V12H8V0Z' fill={props.fillColor || 'black'} />
    <path d='M9 4H11V12H9V4Z' fill={props.fillColor || 'black'} />
    <path d='M14 8H12V12H14V8Z' fill={props.fillColor || 'black'} />
  </SvgIcon>
);

export const MultipleCrescendos = (props) => (
  <SvgIcon xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 12' fill='none' {...props}>
    <path d='M0 8H2V12H0V8Z' fill={props.fillColor || 'black'} />
    <path d='M3 0H5V12H3V0Z' fill={props.fillColor || 'black'} />
    <path d='M8 4H6V12H8V4Z' fill={props.fillColor || 'black'} />
    <path d='M9 0H11V12H9V0Z' fill={props.fillColor || 'black'} />
    <path d='M14 8H12V12H14V8Z' fill={props.fillColor || 'black'} />
  </SvgIcon>
);

export const FreneticIcon = (props) => (
  <SvgIcon xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 12' fill='none' {...props}>
    <path d='M0 2H2V12H0V2Z' fill={props.fillColor || 'black'} />
    <path d='M3 4H5V12H3V4Z' fill={props.fillColor || 'black'} />
    <path d='M8 0H6V12H8V0Z' fill={props.fillColor || 'black'} />
    <path d='M9 2H11V12H9V2Z' fill={props.fillColor || 'black'} />
    <path d='M14 6H12V12H14V6Z' fill={props.fillColor || 'black'} />
  </SvgIcon>
);


//MISC
export const CheckIcon = (props) => (
  <SvgIcon svgClass="CheckIcon" fillRule="evenodd" {...props}>
    <polygon
      fill={props.fillColor || 'black'}
      className="icon-border"
      points="11.941,28.877 0,16.935 5.695,11.24 11.941,17.486 26.305,3.123 32,8.818"
    />
  </SvgIcon>
)